































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Watch, Vue } from 'vue-property-decorator';
import { debounce } from 'lodash';
import StoreDispatcher from '@service/StoreDispatcher';
import StepMixin from '@mixin/step';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            selectedId: null,
            next: {
                disabled: true,
            },
            prev: {
                to: '/apply/new/applicant/aanvrager',
            },
            autosave: false,
            selected: null,
        };
    },

    mixins: [
        StepMixin,
    ],

    methods: {
        selectOrg() {
            this.selected = this.stateOrganisations[this.selectedId];
            this.next.disabled = false;
        },

        deselectOrg() {
            this.selected = null;
            this.selectedId = null,
            this.next.disabled = true;
        },

        async onNext() {
            const data = {
                organisation_id: this.selected.id,
            };

            return StoreDispatcher.createProject(data).then(response => {
                if (response instanceof Error) {
                    this.errorData = this.getErrorMessage(response);
                    return false;
                }

                const project = response;

                // Fetch list again
                return StoreDispatcher.fetchOrganisationList().then(response => {
                    return `/apply/${ project.id }/applicant/kvk`;
                });
            });
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class KiesOrganisatie extends Vue {}

